import { render, staticRenderFns } from "./faqCategories.vue?vue&type=template&id=581cae01&"
import script from "./faqCategories.vue?vue&type=script&lang=js&"
export * from "./faqCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports